import { Grid } from "@mui/material";
import { BtnBack, BtnSave } from "components/Button/ButtonAll";
import DataGrid, { initRows, PaginationInterface } from "components/DataGrid";
import UploadFileItem from "components/Input/UploadFile";
import { I18NextNs } from "enum/enum";
import { useEffect, useRef, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { FnAxios, FnDialog, formatNumber, I18n } from "utilities/utilities";
import { useNavigate } from "react-router";
import { GetMenuPermission } from "utilities/SystemFunction";

export const ImportETicket = () => {
    const navigate = useNavigate();

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const handleClearExcelFile = useRef(null);

    const [arrImportExcel, setArrImportExcel] = useState([]);
    const [arrTicket, setArrTicket] = useState([]);
    const [nMuseumID, setNMuseumID] = useState(null);
    const [sPath, setSPath] = useState("");
    const [sFileName, setSFileName] = useState("");
    const [sSystemFileName, setSSystemFileName] = useState("");
    const [isLoadingTable, setIsLoadingTable] = useState(false);
    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dTicketDate",
        sSortDirection: "asc"
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);

        if (arrImportExcel.length > 0) {
            handleImportExcel(dataRow);
        } else {
            setArrTicket([]);
            setDataRow({
                ...dataRow,
                arrRows: [],
                nDataLength: 0,
                nPageIndex: 1
            });
        }

    }, [arrImportExcel]);

    const handleClearImport = () => {
        setArrTicket([]);
        setNMuseumID(null);
        setSPath("");
        setSFileName("");
        setSSystemFileName("");

        handleClearExcelFile.current();
        setArrImportExcel([]);
        setArrTicket([]);
        setDataRow({
            ...dataRow,
            arrRows: [],
            nDataLength: 0,
            nPageIndex: 1
        });
    }

    const onBack = () => {
        navigate(`/e-ticket`);
    }

    const handleSubmit = () => {

        let param = {
            nMuseumID: nMuseumID,
            lstTicketSummary: arrTicket,
            sPath: sPath,
            sFileName: sFileName,
            sSystemFileName: sSystemFileName
        }
        DialogFn.Submit(
            I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent)
            , () => {
                AxiosFn.Post(`ETicket/SaveTicket`, param, (result) => {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent),
                        () => {
                            handleClearImport();
                            setIsLoadingTable(false);
                            onBack();
                        });

                }, (err) => {
                    DialogFn.Warning(err.Message);
                    handleClearImport();
                    setIsLoadingTable(false);
                });
            })
    }

    const handleImportExcel = (p: PaginationInterface) => {
        setIsLoadingTable(true);
        let param = {
            lstFileUpload: arrImportExcel || []
        }

        AxiosFn.Post(`ETicket/OnImportExcel`, param, (result) => {
            if (result.nStatusCode === 200) {
                if ([...result.lstError].length > 0) {
                    let sText = `ข้อมูลไม่ถูกต้อง รายละเอียดดังนี้<br><br>${[...result.lstError].join("<br>")}`;
                    handleClearExcelFile.current();
                    DialogFn.Warning(sText);
                } else {
                    let data = [...result.lstTicketSummary];
                    setArrTicket(data);
                    setNMuseumID(result.nMuseumID);
                    setSPath(result.sPath);
                    setSFileName(result.sFileName);
                    setSSystemFileName(result.sSystemFileName);

                    let ticket = data.slice(0, 10);
                    let nNo = 1;

                    ticket.forEach(item => {
                        item.nNo = nNo++;
                    });
                    setDataRow({
                        ...p,
                        arrRows: [...ticket],
                        nDataLength: data.length
                    });
                }
            }

            setIsLoadingTable(false);
        }, (err) => {
            DialogFn.Warning(err.Message);
            handleClearImport();
            setIsLoadingTable(false);
        });
    }

    const UpdateTableImport = (p: PaginationInterface = dataRow) => {
        setIsLoadingTable(true);
        let nPageIndex = Math.max(0, p.nPageIndex - 1);
        let skip = p.nPageSize * nPageIndex;
        let take = skip + p.nPageSize;
        if (take > arrTicket.length) {
            take = arrTicket.length
        }

        let result = arrTicket.slice(skip, take);

        let nNo = 1;

        result.forEach(item => {
            item.nNo = nNo++;
        });
        console.log("p", p)
        setDataRow({
            ...p,
            nPageIndex: nPageIndex + 1,
            arrRows: [...result],
            nDataLength: [...arrTicket].length
        });

        setIsLoadingTable(false);
    }

    const sNo: any = {
        field: 'nNo',
        headerName: 'ที่',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        sortable: false,
        isSort: false,
        collapse: false
    };

    const sTicketDate: any = {
        field: 'sTicketDate',
        headerName: 'ประจำเดือน ปี',
        headerAlign: 'center',
        align: 'center',
        flex: 3,
        sortable: false,
        isSort: false,
        collapse: false
    };

    const sTotalTicket: any = {
        field: 'nTotalTicket',
        headerName: 'จำนวนบัตรทั้งหมด',
        headerAlign: 'center',
        align: 'center',
        flex: 2,
        sortable: false,
        isSort: false,
        collapse: false,
        renderCell: (item) => {
            return [
                <>
                    {formatNumber(item.row.nTotalTicket, 0)}
                </>
            ]
        }
    };

    const sTotalAmount: any = {
        field: 'nTotalAmount',
        headerName: 'จำนวนเงินทั้งหมด',
        headerAlign: 'center',
        align: 'center',
        flex: 2,
        sortable: false,
        isSort: false,
        collapse: false,
        renderCell: (item) => {
            return [
                formatNumber(item.row.nTotalAmount, 2)
            ]
        }
    };

    const sTotalAudience: any = {
        field: 'nTotalAudience',
        headerName: 'จำนวนผู้เข้าชมทั้งหมด',
        headerAlign: 'center',
        align: 'center',
        flex: 2,
        sortable: false,
        isSort: false,
        collapse: false,
        renderCell: (item) => {
            return [
                formatNumber(item.row.nTotalAudience, 0)
            ]
        }
    };

    let dataColumn = [sNo, sTicketDate, sTotalTicket, sTotalAmount, sTotalAudience] as any[];

    return (
        <FormProvider {...form}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <UploadFileItem
                        name="importeticket"
                        label="นำเข้าข้อมูล E-Ticket"
                        modeDisplay="list"
                        nLimitFile={30}
                        sLimitFile="MB"
                        nCountLimitFile={1}
                        sFolderTemp="FolderExample/e-ticket"
                        Extension={["xlsx"]}
                        sPositionText="right"
                        arrFile={arrImportExcel}
                        setarrFile={setArrImportExcel}
                        IsMultiple={false}
                        IsFolder={false}
                        onClearFile={handleClearExcelFile}
                        required
                        disabled={!isPermission}
                    />
                </Grid>
                <Grid item xs={12} mt={dataRow.arrRows.length > 0 ? 0 : 2}>
                    {dataRow.arrRows.length > 0 &&
                        <span style={{ color: "red" }}>*กรุณาตรวจสอบความถูกต้อง จำนวนบัตร, จำนวนเงิน และจำนวนผู้เข้าชม</span>
                    }
                    <DataGrid
                        sTableID='importticket'
                        columns={dataColumn}
                        rows={dataRow}
                        isLoading={isLoadingTable}
                        onLoadData={(p) => { UpdateTableImport(p) }}
                        isHiddenToolHead
                        isShowCheckBox={false}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2} justifyContent={"center"}>
                        <Grid item>
                            <BtnBack id={"btnBack"} onClick={() => { navigate("/e-ticket") }} />
                        </Grid>

                        <Grid item>
                            <BtnSave
                                id={"btnSave"}
                                onClick={form.handleSubmit(
                                    () => { handleSubmit() },
                                    (err) => console.log("err", err)
                                )}
                                IsDisabled={arrImportExcel.length === 0 || !isPermission}
                            />
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        </FormProvider>
    )
}